import { render, staticRenderFns } from "./ProductCategoryPanel.vue?vue&type=template&id=61902e48&scoped=true"
import script from "./ProductCategoryPanel.vue?vue&type=script&lang=js"
export * from "./ProductCategoryPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryPanel.vue?vue&type=style&index=0&id=61902e48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61902e48",
  null
  
)

export default component.exports